import {Routes} from '@angular/router';
import {ProfessionalLiabilityPageComponent} from './professional-liability-page.component';
import {MalpracticeScreenComponent} from './steps/malpractice/malpractice-screen.component';
import {LicensesAndAffiliationsScreenComponent} from './steps/licenses-and-affiliations/licenses-and-affiliations-screen.component';
import {DisciplinaryActionsScreenComponent} from './steps/disciplinary-actions/disciplinary-actions-screen.component';
import {HealthStatusScreenComponent} from './steps/health-status/health-status-screen.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
const routes: Routes = [{
    path: 'liabilityAndDisclosure',
    component: ProfessionalLiabilityPageComponent,
    children: [
        {path: '', redirectTo: 'malpractice', pathMatch: 'full'},
        {path: 'malpractice', component: MalpracticeScreenComponent},
        {path: 'licensesAndAffiliations', component: LicensesAndAffiliationsScreenComponent},
        {path: 'disciplinaryActions', component: DisciplinaryActionsScreenComponent},
        {path: 'healthStatus', component: HealthStatusScreenComponent}
    ],
    data: {section: {title: 'Liability and Disclosure'}, impersonationAllowed: true}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/liability/professional-liability-page.routing.ts